export default "__VITE_ASSET__DYzNpqMo__"